import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

export const Border = ['xsmall', 'small', 'medium'] as const;
export const Shadow = ['lv1', 'lv2', 'lv3', 'lv4', 'small', 'medium'] as const;

const cardProps = {
  border: String,
  gradient: Boolean,
  paddingHorizontal: Number,
  paddingVertical: Number,
  shadow: String,
};

export type CardProps = {
  border: typeof Border[number];
  gradient: boolean;
  paddingHorizontal: number;
  paddingVertical: number;
  shadow: typeof Shadow[number];
};

export const Header = styled.header`
  align-items: center;
  border-bottom: 2px solid #F1F2F0;
  display: flex;
  gap: ${theme.spacings.medium};
  padding: ${theme.spacings.medium} ${theme.spacings.xxxlarge};
`;

export const Wrapper = styled('div', cardProps)`
  ${({
    border, gradient, paddingHorizontal, paddingVertical, shadow,
  }: CardProps) => css`
    background: ${gradient
    ? `linear-gradient(180deg, #F2F2F2 0%, ${theme.colors.white} 0.01%, rgba(255, 255, 255, 0.85) 100%)`
    : theme.colors.white};
    border-radius: ${theme.border.radius[border]};
    box-shadow: ${theme.shadow[shadow]};
    height: auto;
    padding: ${paddingVertical}px ${paddingHorizontal}px;
    position: relative;
    width: auto;
    z-index: ${theme.layers.base};
  `}
`;

export const WrapperButtons = styled.div`
  display: flex;
  gap: ${theme.spacings.small};
  margin-left: auto;

  & > a {
    display: flex;
    margin-left: ${theme.spacings.large};
  }
`;
